
import { defineComponent, PropType } from "vue";
import TUIViewer from "../../components/application/TUIViewer.vue";
import { Product } from "domain/entities/shop/product/product";

export default defineComponent({
  components: {
    TUIViewer,
  },
  props: {
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
    formatDecoins: {
      type: Function as PropType<(decoins: number) => number>,
      required: true,
    },
    checkProductIsActive: {
      type: Function as PropType<(product: Product) => boolean>,
      required: true,
    },
    isProductOutOfStock: {
      type: Function as PropType<(product: Product) => boolean>,
      required: true,
    },
  },
});
